export default "__VITE_ASSET__CUESF5nM__"